import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import GymLogo from '../layout/GymLogo';

function RichText({ text, skip }) {
  const token = /(https?:\/\/[^\s]+|Cookie Policy|Privacy Policy|\bqui\b)/g;
  const parts = text.split(token);
  return parts.map((part, index) => {
    if (!part) return null;
    if (part === skip) {
      return <span key={index}>{part}</span>;
    }
    if (part === 'Privacy Policy') {
      return (
        <Link key={index} to="/privacy-policy" className="underline underline-offset-2 text-[#372d83] dark:text-indigo-300">
          Privacy Policy
        </Link>
      );
    }
    if (part === 'Cookie Policy') {
      return (
        <Link key={index} to="/cookie-policy" className="underline underline-offset-2 text-[#372d83] dark:text-indigo-300">
          Cookie Policy
        </Link>
      );
    }
    if (part === 'qui' && text.includes('cliccare qui')) {
      return (
        <Link key={index} to="/privacy-policy" className="underline underline-offset-2 text-[#372d83] dark:text-indigo-300">
          qui
        </Link>
      );
    }
    if (part.startsWith('http')) {
      const href = part.replace(/[.,;)]+$/, '');
      const trail = part.slice(href.length);
      return (
        <span key={index}>
          <a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 break-all text-[#372d83] dark:text-indigo-300">
            {href}
          </a>
          {trail}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
}

export default function LegalDocument({ document }) {
  const { isDark } = useTheme();
  const { openPreferences } = useCookieConsent();

  return (
    <div className={`min-h-screen ${isDark ? 'bg-gray-950 text-gray-200' : 'bg-[#f4f2fb] text-gray-800'}`}>
      <header className={`border-b ${isDark ? 'border-white/10 bg-gray-900' : 'border-[#dad8e5] bg-white'}`}>
        <div className="max-w-3xl mx-auto px-4 py-5 flex items-center justify-between gap-4">
          <Link to="/login" className="shrink-0" aria-label="Torna all'accesso">
            <GymLogo variant="full" className="!h-10 w-auto text-[#372d83]" />
          </Link>
          <Link
            to="/login"
            className={`text-sm font-medium underline-offset-2 hover:underline ${isDark ? 'text-gray-300' : 'text-[#372d83]'}`}
          >
            Torna all&apos;accesso
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <article className={`rounded-2xl border px-5 py-8 sm:px-10 sm:py-12 ${isDark ? 'bg-gray-900 border-white/10' : 'bg-white border-[#dad8e5]'}`}>
          <h1 className="font-open-sans text-3xl font-bold text-[#372d83] dark:text-white">{document.title}</h1>
          <p className={`mt-2 text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{document.updated}</p>
          <div className="mt-8 space-y-4 text-[15px] leading-7">
            {document.blocks.map((block, index) => {
              if (block.type === 'h2') {
                return (
                  <h2 key={index} className="pt-6 text-xl font-bold text-[#372d83] dark:text-white">
                    {block.text}
                  </h2>
                );
              }
              if (block.type === 'h3') {
                return (
                  <h3 key={index} className="pt-4 text-base font-semibold text-gray-900 dark:text-gray-100">
                    {block.text}
                  </h3>
                );
              }
              if (block.type === 'ul') {
                return (
                  <ul key={index} className="list-disc pl-5 space-y-1">
                    {block.items.map((item) => (
                      <li key={item}>
                        <RichText text={item} skip={document.title} />
                      </li>
                    ))}
                  </ul>
                );
              }
              return (
                <p key={index}>
                  <RichText text={block.text} skip={document.title} />
                </p>
              );
            })}
          </div>
          <p className="mt-10 text-center">
            <button
              type="button"
              onClick={openPreferences}
              className="text-xs text-[#9e96c7] underline-offset-2 hover:underline dark:text-white/50"
            >
              Preferenze cookie
            </button>
          </p>
        </article>
      </main>
    </div>
  );
}
